import {initializeApp} from 'firebase/app'
import {getAnalytics} from 'firebase/analytics'
import {getMessaging, getToken, MessagePayload, onMessage} from 'firebase/messaging'
import NotificationService from '../services/handler/notifications/notifications.service'
import {Modal} from 'antd'

const firebaseConfig = {
  apiKey: 'AIzaSyC86vmOf7qBUhNu-d2vU8_caM78tV1IzTA',
  authDomain: 'loaphuong-47fb2.firebaseapp.com',
  projectId: 'loaphuong-47fb2',
  storageBucket: 'loaphuong-47fb2.firebasestorage.app',
  messagingSenderId: '534067665046',
  appId: '1:534067665046:web:daf6b7da0e7faa84ff0ab7',
  measurementId: 'G-8325QBQC4T',
}

const app = initializeApp(firebaseConfig)
const messaging = getMessaging(app)

export async function getMessagingToken(configs: any) {
  try {
    const currentToken = await getToken(messaging, {
      vapidKey:
        'BN9FXrOKydmRrRzX_L6AEMDpAYgz5CB3A0TLhpW67jCZ49IXUVjAmVfLnR5F7YroyxCOJAJ5ZOtCmkFgOp5v-CU',
    })
    localStorage.setItem('fcm_token', JSON.stringify(currentToken))
    await NotificationService.firebaseRegisterFCMToken(configs, currentToken)
  } catch (error: any) {
    if (error?.code === 'messaging/permission-blocked') {
      Modal.confirm({
        title: 'Vui lòng cấp quyền nhận thông báo!',
        okText: 'OK',
        cancelText: 'Hủy',
        onOk: () => {
          // TODO: gọi API xử lý payload
          // Example: someService.handleIncident(payload)
        },
      })
    }
  }
}

export const onMessageListener = (): Promise<MessagePayload> =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload)
    })
  })
